var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12,
    stroke: "#141312",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8337 22.6673C16.8337 23.1276 16.4606 23.5007 16.0003 23.5007C15.5401 23.5007 15.167 23.1276 15.167 22.6673C15.167 22.2071 15.5401 21.834 16.0003 21.834C16.4606 21.834 16.8337 22.2071 16.8337 22.6673Z",
    fill: "#141312",
    stroke: "#141312"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0419 18.6673V17.4332V17.4332C16.0419 16.833 16.3893 16.2872 16.9329 16.033L17.6745 15.6863C17.9319 15.566 18.1698 15.4076 18.38 15.2165L18.466 15.1384C19.4053 14.2845 19.7787 12.9714 19.429 11.7511V11.7511C19.019 10.3201 17.7107 9.33398 16.2222 9.33398H16.0419V9.33398C13.8096 9.33398 12 11.1436 12 13.3759V13.744",
    stroke: "#141312",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSign);
export default __webpack_public_path__ + "static/media/help_sign.6ee1cb658eba9e0645bb2c0814d59d5f.svg";
export { ForwardRef as ReactComponent };